import React from 'react';
import pluralize from 'pluralize';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import RaisedButton from '../../../tc-ui/raised-button-with-loader';

const CongratulationPage = ({ files, updateProps, router, createdContract }) => (
  <div style={{ textAlign: 'center' }}>
    Your {pluralize('file', files.length)} {pluralize('was', files.length)} successfully added!
    <br/>
    <br/>
    <div style={{ textAlign: 'center' }}>
      <FlatButton
        secondary
        label="Go to Contract List"
        onTouchTap={() => {
          updateProps('action_dialog', { open: false });
          router.replace(`/messaging/notdone/contract/${createdContract._id}`);
          router.push('/contracting/contract-list/recent');
        }}
      />
      <RaisedButton
        secondary
        label="View Contract"
        onTouchTap={() => {
          updateProps('action_dialog', { open: false });
          router.push(`/contracting/contract/${createdContract._id}/details`);
        }}
      />
    </div>
  </div>
);
export default CongratulationPage;



// WEBPACK FOOTER //
// ./src/app/components/messaging/singleConv/dialog/congratulation.jsx